import styled from "styled-components";
import { Container } from "react-bootstrap";

export const StyledContainer = styled(Container)`
  min-height: ${(props) => (props.height ? props.height : "initial")}vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
